import React from 'react';
import { CircularProgress } from '@rmwc/circular-progress';

export default function Loader(){
    return (
        <CircularProgress size="xlarge" className="loader"/> 
    );
}